import { Icons } from '@/utils/Icons';
import React, { useEffect, useState } from 'react';
import MyBets from './MyBets';
import { useAppDispatch, useAppSelector } from '@/hooks';
import { toggleEditStake } from '@/store';
import { useBetPlaceMutation, useGetStakesQuery } from '@/store/api/betApi';
import { PlaceBetPayload } from '@/types/Bet';
import { clearBet, setBetRate, setStakeAmount } from '@/store/slices/betSlice';
import { formatNumber } from '@/utils';
import ComponentLoader from './common/ComponentLoader';
import { useLocation } from 'react-router-dom';


const BettingContainer = () => {
  return (
    <div className="sticky top-0 max-xl:hidden text-black w-[350px] 2xl:w-[400px] 3xl:w-[450px] pl-[2px] min-h-[calc(100vh-135px)] max-h-[calc(100vh-135px)] overflow-x-hidden overflow-y-auto ml-0">
      <BetSlip />
    </div>
  );
};

export default BettingContainer;

function BetSlip() {
  const [betPlace, { data, isLoading: IsBetPlacing }] = useBetPlaceMutation();
  const [openTv, setOpenTv] = useState<boolean>(false);
  const [acceptOddsChange, setAcceptOddsChange] = useState<boolean>(false);
  const { data: stakeData, refetch } = useGetStakesQuery();
  const { selectedBet } = useAppSelector((state) => state.bet);
  const betDetails = useAppSelector((state) => state.bet);
  const [stake, setStake] = useState(0);
  const { liveTvUrl } = useAppSelector((state) => state.media);
  const location = useLocation();
  const profit =
    selectedBet?.betOn == 'BACK' ? formatNumber((Number(selectedBet?.rate) - 1) * stake) : stake;

  const bookmakerProfit =
    selectedBet?.betOn == 'BACK' ? formatNumber((Number(selectedBet?.rate) * stake) / 100) : stake;

  const addStake = (value: number) => {
    setStake((prev) => prev + value);
  };

  const reset = () => {
    dispatch(clearBet());
    setStake(0);
  };
  const dispatch = useAppDispatch();

  const handleBetPlace = async () => {
    if (!selectedBet) return;

    const {
      eventId,
      marketId,
      marketName,
      marketCategory,
      marketType,
      selectionId,
      runnerName,
      betOn,
      rate,
      fancyPercentage,
    } = selectedBet;

    if (!eventId || !marketId || !marketName || !selectionId || !runnerName || !rate || !betOn) {
      return;
    }

    const payload: PlaceBetPayload = {
      eventId,
      marketId,
      marketName,
      marketCategory: marketCategory!,
      marketType: marketType!,
      selectionId,
      runnerName,
      betOn: betOn,
      stake: stake,
      rate,
      fancyPercentage,
      acceptOddsChange,
    };
    try {
      const result = await betPlace(payload).unwrap();
      dispatch(clearBet());
      setStake(0);
    } catch (error: unknown) {
      console.log(error);
    }
  };

  const increaseRate = () => {
    dispatch(setBetRate(Number((Number(betDetails.selectedBet?.rate ?? 0) + 0.01).toFixed(2))));
  };

  const decreaseRate = () => {
    dispatch(
      setBetRate(Number(Math.max(0, Number(betDetails.selectedBet?.rate ?? 0) - 0.01).toFixed(2)))
    );
  };
  const handleRateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (!/^\d*\.?\d*$/.test(value)) return;

    dispatch(setBetRate(Number(value)));
  };

  useEffect(() => {
    dispatch(setStakeAmount(stake));
  }, [stake]);

  useEffect(() => {
    dispatch(clearBet());
  }, [location.pathname]);

  return (
    <div className="text-sm font-sans overflow-y-auto">
      {/* Live Match title */}
      <div
        onClick={() => setOpenTv((prev) => !prev)}
        className="cursor-pointer bg-secondary text-white px-2 py-1 border-t border-gray-700 font-bold"
      >
        Live Match
      </div>
      {openTv && liveTvUrl && (
        <div className="w-full aspect-video overflow-hidden">
          {' '}
          <iframe scrolling="no" className="w-full h-full" src={liveTvUrl}></iframe>
        </div>
      )}
      {/* Place Bet title */}
      {selectedBet && (
        <>
          <div
            onClick={(e: any) => e.stopPropagation()}
            className="bg-secondary text-white px-2 py-1 border-t border-gray-700 mt-1 font-bold"
          >
            Place Bet
          </div>
          {/* Bet Box */}
          <div
            className={`relative ${selectedBet?.betOn?.toLowerCase() == 'back' ? 'bg-back' : 'bg-lay'}`}
          >
            {/* Table header */}
            <div className="grid grid-cols-4 bg-gray-300 text-black font-bold px-2 py-1">
              <span>(Bet for)</span>
              <span className="text-center">Odds</span>
              <span className="text-center">Stake</span>
              <span className="text-right">Profit</span>
            </div>

            {/* Bet Row */}
            <div className="flex items-center px-2 py-1">
              <span className="font-bold w-[calc(100%-230px)]">{selectedBet?.runnerName}</span>
              <div className="flex w-[60px]">
                <input
                  value={selectedBet?.rate ? selectedBet?.rate : ''}
                  onChange={handleRateChange}
                  className="h-6 w-full text-center bg-white border"
                />
                <div className="bg-neutral-400">
                  <button
                    onClick={increaseRate}
                    className="h-3 w-5 flex items-center justify-center"
                  >
                    <Icons.Up className="text-xs" />
                  </button>
                  <button
                    onClick={decreaseRate}
                    className="h-3 w-5 flex items-center justify-center"
                  >
                    <Icons.Down className="text-xs" />
                  </button>
                </div>
              </div>
              <input
                type="text"
                value={stake}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^[0-9]*$/.test(value)) {
                    setStake(Number(value));
                  }
                }}
                inputMode="numeric"
                className="ml-[10px] w-20 h-6 text-center bg-white border appearance-none"
              />
              <span className="w-20 text-right font-bold">
                {selectedBet?.marketType?.toLowerCase() == 'fancy'
                  ? 0
                  : selectedBet?.marketCategory?.toLowerCase() == 'bookmaker'
                    ? bookmakerProfit
                    : profit}
              </span>
            </div>

            {/* Chips */}
            <div className="flex p-1 gap-[2px] justify-start flex-wrap mt-2">
              {stakeData?.stakeSet?.map(({ value, label }, index) => (
                <button
                  key={index}
                  onClick={() => addStake(value)}
                  className="w-[calc(20%-2px)] bg-gray-300 p-[5px] text-sm font-bold hover:bg-gray-400"
                >
                  +{label}
                </button>
              ))}
            </div>
            {/* Actions */}
            <div className="flex justify-between">
              {/* Clear */}
              <button
                onClick={() => setStake(0)}
                className="text-base underline text-gray-800 min-w-20 w-[25%] h-[38px]"
              >
                clear
              </button>
              <button
                onClick={() => dispatch(toggleEditStake())}
                className="flex-1 bg-info-cyan-darker text-body-inverse py-2 min-w-20 w-[25%] h-[38px]"
              >
                Edit
              </button>

              <button
                onClick={reset}
                className="flex-1 bg-danger-dark text-body-inverse py-2 min-w-20 w-[25%] h-[38px]"
              >
                Reset
              </button>

              <button
                onClick={handleBetPlace}
                className="flex-1 bg-success-dark text-body-inverse py-2 min-w-20 w-[25%] h-[38px]"
              >
                Submit
              </button>
            </div>
            {IsBetPlacing && <ComponentLoader />}
          </div>
        </>
      )}
      {/* My Bet Header */}
      <div className="bg-secondary text-white px-3 py-1 font-semibold mt-1">My Bet</div>
      <MyBets />
    </div>
  );
}
